/* eslint-disable no-undef */
export default () => __('content');
